import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscarFeriadoModel } from "../models/feriado/chamadas/buscarFeriadoModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarFeriado, setModalDeletarFeriado } from "../redux/slices/feriado/feriadoSlice";

export const cadastrarFeriado = createAsyncThunk("/Feriado/CadastrarFeriado", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/Feriado/CadastrarFeriado", payload.value);
    toastSucess("Feriado cadastrado com sucesso");
    dispatch(setModalCadastrarFeriado(false));
    dispatch(setLoading(false));

    dispatch(buscarFeriado(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarFeriado = createAsyncThunk("/Feriado/BuscarFeriado", async (args: BuscarFeriadoModel) => {
  try {
    const data = await api.get("/Feriado/BuscarFeriado", { params: args });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarFeriado = createAsyncThunk("/Feriado/AtualizarFeriado", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Feriado/AtualizarFeriado", payload.value);
    toastSucess("Feriado atualizado com sucesso");
    dispatch(setModalCadastrarFeriado(false));
    dispatch(setLoading(false));

    dispatch(buscarFeriado(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarFeriado = createAsyncThunk("/Feriado/DeletarFeriado", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/Feriado/DeletarFeriado", {
      params: { id: payload.value },
    });
    toastSucess("Feriado removido com sucesso");
    dispatch(setModalDeletarFeriado(false));
    dispatch(setLoading(false));

    dispatch(buscarFeriado(payload.busca));
  } catch (e: any) {
    dispatch(setLoading(false));
    toastError(e.response.data.Message);
  }
});
